/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import ChatFaqService from 'src/services/chat-bot-faq.service';

export const useAddFaq = (): UseMutationResult<any, Error, { faq: any }, void> =>
  useMutation(({ faq }: { faq: any }) => ChatFaqService.addFaq(faq), {
    onSuccess: () => {
      AlertAdapter('FAQ Added successfully', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useUpdateFaq = (): UseMutationResult<any, Error, { faqId: string; faq: any }, void> =>
  useMutation(({ faqId, faq }: { faqId: string; faq: any }) => ChatFaqService.updateFaq(faqId, faq), {
    onSuccess: () => {
      AlertAdapter('FAQ Added successfully', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
